import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Logotipo from "../../../images/logotipo-home.svg";
import TimelineRegister from "../timelineRegister";
import "./header.scss";

class Header extends PureComponent {
  getPreference() {
    const { user } = this.props;

    if (user.situation === "guest") {
      return "/";
    }
    if (user.preference === "superior") {
      return "/superior";
    }
    return "/medio";
  }

  render() {
    const { showTimeline = false, step = 0 } = this.props;
    const userPreference = this.getPreference();

    return (
      <div className="register-header">
        <div className="register-header-img">
          <Link to={userPreference}>
            <img src={Logotipo} alt="Aprova Total" />
          </Link>
        </div>
        {showTimeline && <TimelineRegister step={step} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const user = state.app.data.user;

  return {
    user
  };
};

export default connect(mapStateToProps)(Header);
